import React from "react";
import { styled } from "../../theme/styled";
import type {
  BorderRadiusToken,
  ColorToken,
  ColorValue,
} from "../../theme/styled/designTokens";

interface Props {
  children: React.ReactNode;
  backgroundColor: BackgroundColor;
  size: number;
  radius?: BorderRadiusToken;
  borderColor?: ColorToken;
}

type BackgroundColor = ColorToken | `!!${ColorValue}`;

export const RoundedBackground = ({
  children,
  backgroundColor,
  borderColor,
  size,
  radius = "$radius-circle",
}: Props): React.JSX.Element => {
  return (
    <StyledBackground
      radius={radius}
      size={size}
      backgroundColor={backgroundColor}
      borderColor={borderColor}
    >
      {children}
    </StyledBackground>
  );
};

const StyledBackground = styled("div")<{
  size: number;
  backgroundColor: ColorToken | `!!${ColorValue}`;
  radius?: Props["radius"];
  borderColor?: ColorToken;
}>((props) => ({
  height: `${props.size}px`,
  width: `${props.size}px`,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: props.radius,
  backgroundColor: props.backgroundColor,
  border: props.borderColor ? `1px solid ${props.borderColor}` : undefined,
}));
